<template>
  <v-container
    id="container-checkout"
    fluid
    fill-height
    pa-0
    ma-0
    class="test_green"
  >
    <v-toolbar v-if="isReady" fixed class="fixed-toolbar">
      <v-btn icon @click="$router.push({ name: 'Discovery' })">
        <v-icon v-text="'mdi-arrow-left'" />
      </v-btn>

      <v-toolbar-title>Back to discovery page</v-toolbar-title>
      <v-spacer></v-spacer>
      <Language />
      <div v-if="$store.getters.checkAuth" class="px-2">
        <ProfileCustomer />
      </div>
    </v-toolbar>
    <SpinnerLoader v-if="!isReady" />
    <v-row
      v-else
      no-gutters
      justify="center"
      align="start"
      class="test_orange fill-height main-content"
    >
      <v-col
        cols="12"
        md="6"
        xl="4"
        class="test_purple pa-2 pa-sm-10 header mt-15"
      >
        <v-row no-gutters class="test_yellow">
          <CustomTab class="mb-8" @tab-change="handleTabChange" />
          <v-col
            v-if="!$store.getters.checkAuth"
            cols="12"
            class="test_orange mb-10"
          >
            <SectionTitle
              :title="$t('checkout.information')"
              :number="sectionNumbers.information"
            />
            <CustomerInfo
              v-model="customValid"
              @cleanPaymentInfo="handlerCleanPaymentData()"
            />
          </v-col>

          <v-col v-if="tab === 'delivery'" cols="12" class="test_green mb-10">
            <SectionTitle
              :title="$t('checkout.where_question')"
              :number="sectionNumbers.where"
            />
            <WhereSection />
          </v-col>

          <v-col cols="12" class="test_green mb-10">
            <SectionTitle
              :title="$t('checkout.when_question')"
              :number="sectionNumbers.when"
            />
            <WhenSection />
          </v-col>

          <v-col cols="12" class="test_purple mb-10">
            <SectionTitle
              :title="$t('checkout.selected_items')"
              :number="sectionNumbers.items"
            />
            <CartItems v-model="comments" />
          </v-col>

          <v-col cols="12" class="test_purple mb-10">
            <SectionTitle
              :title="$t('checkout.payment')"
              :number="sectionNumbers.payment"
            />
            <PaymentX v-model="paymetInfo" :stripe="stripe" />
            <!--            <Payment v-model="paymetInfo" :stripe="stripe" />-->
            <CreditToggle
              v-if="$store.getters.user && $store.getters.user?.credits > 0"
            />
          </v-col>
          <v-col
            v-if="$vuetify.breakpoint.smAndDown"
            cols="12"
            class="test_purple pb-10"
          >
            <!--            <CardCheckout-->
            <!--              @click="checkoutX()"-->
            <!--              @onClickDiscount="showDialogOfferCode = true"-->
            <!--            />-->
            <CardCheckoutX
              @click="checkoutX()"
              @onClickDiscount="showDialogOfferCode = true"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        v-if="$vuetify.breakpoint.mdAndUp"
        cols="12"
        md="5"
        xl="4"
        class="test_pink checkout-card-column"
      >
        <div class="fixed-card-container">
          <CardCheckoutX
            @click="checkoutX()"
            @onClickDiscount="showDialogOfferCode = true"
          />
        </div>
      </v-col>
    </v-row>
    <MetaDataComponent
      v-if="metaTitle && metaDescription && metaKeywords"
      :title="metaTitle"
      :description="metaDescription"
      :keywords="metaKeywords"
    />
    <v-dialog
      v-model="showDialogOfferCode"
      persistent
      width="600"
      transition="dialog-bottom-transition"
      content-class="dialog-rounded"
      :scrollable="false"
    >
      <OfferCode
        v-if="showDialogOfferCode"
        v-model="offerCode"
        @close="showDialogOfferCode = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
/*
Actions:
  Meta tab translate
  middleware session cart
  show offer validation with code
  Load delivery services
  check param, redirect home
  if its offline, redirect
*/
/*
New Validation:
1. Login-Guess
2. Delivery

*/
import {
  CardCheckoutX,
  CartItems,
  CustomerInfo,
  CustomTab,
  OfferCode,
  PaymentX,
} from "./components";
import i18n from "@/plugins/i18n";
import CreditToggle from "@/views/front/checkout/components/CreditToggle.vue";
import MetaDataComponent from "@/components/metaDataComponent/MetaDataComponent.vue";
import orderMixin from "@/mixins/orderMixin";
import SectionTitle from "@/components/common/SectionTitle.vue";
import WhenSection from "@/views/front/checkout/components/deliveryComponets/WhenSection.vue";
import { WhereSection } from "@/views/front/checkout/components/deliveryComponets/index.js";

export default {
  layout: "Public",
  middleware: "sessionCart",
  name: "Checkout",
  components: {
    CustomerInfo,
    CartItems,
    PaymentX,
    CardCheckoutX,
    OfferCode,
    CreditToggle,
    MetaDataComponent,
    CustomTab,
    SectionTitle,
    WhenSection,
    WhereSection,
  },
  mixins: [orderMixin],
  data: () => ({
    // isReady: false,
    updateKey: 0,
    stripe: null,
    showDialogOfferCode: false,
    paymetInfo: [],
    comments: null,
    offerCode: null,
    paymentId: null,
    customValid: false,
    tab: "pickup",
    initialized: false,
  }),
  computed: {
    sectionNumbers() {
      const isDelivery = this.tab === "delivery";
      const isAuth = this.$store.getters.checkAuth;

      let where = isAuth ? 1 : 2;
      let when, items, payment;

      if (isAuth && !isDelivery) {
        when = 1;
        items = 2;
        payment = 3;
      } else if (isAuth && isDelivery) {
        where = 1;
        when = 2;
        items = 3;
        payment = 4;
      } else if (!isAuth && isDelivery) {
        when = 3;
        items = 4;
        payment = 5;
      } else {
        // !isAuth && !isDelivery
        when = 2;
        items = 3;
        payment = 4;
      }

      return {
        information: 1,
        where,
        when,
        items,
        payment,
      };
    },
    isReady: {
      get() {
        return this.$store.getters.deliveryServicesList.length > 0
          ? true
          : false;
      },
      set(val) {
        return val ? true : false;
      },
    },
    stripeElements() {
      return this.stripe.elements();
    },
    metaTitle() {
      return this.$store.getters.appInfo.checkoutMetaTitle;
    },
    metaDescription() {
      return this.$store.getters.appInfo.checkoutMetaDescription;
    },
    metaKeywords() {
      return this.$store.getters.appInfo.checkoutMetaKeywords;
    },
  },
  watch: {
    // Watch for changes in deliveryServicesList to initialize tabs
    "$store.getters.deliveryServicesList": {
      handler(newVal) {
        if (newVal && newVal.length > 0 && !this.initialized) {
          this.handlerLoadTab();
          this.initialized = true;
        }
      },
      immediate: true,
    },
    // Watch for store info to initialize Stripe
    "$store.getters.storeInfo": {
      handler(newVal) {
        if (newVal && !this.stripe) {
          try {
            // eslint-disable-next-line no-undef
            this.stripe = Stripe(this.$store.getters.storeInfo.publishableKey);
          } catch (error) {
            console.error("Error initializing Stripe:", error);
          }
        }
      },
      immediate: true,
    },
    "$store.getters.deliveryMethod": function () {
      if (this.$store.getters.deliveryMethod === "pickup-service") {
        this.$store.dispatch("delivery/resetAll");
      }
      console.log("TKPPPPP");
      this.$checkoutValidator.deliveryInfo();
      this.$checkoutValidator.minOrderAmount();
    },
    "$store.getters.guestAddress": function () {
      this.$checkoutValidator.deliveryInfo();
    },
    "$store.getters.deliveryIsAsap": function () {
      this.$checkoutValidator.deliveryWhen();
    },
    "$store.getters.checkAuth": function () {
      this.$checkoutValidator.customerInfo();
      this.showModalServices = true;
    },
  },
  /*   watch: {
    "$store.getters.checkAuth": function () {

      if (!this.$store.getters.checkAuth) {
        this.updateKey += 1;
      }
    },
  }, */
  beforeMount() {
    if (this.$store.getters.storeInfo) {
      this.$store.dispatch("checkout/loadDeliveryServices");
      // eslint-disable-next-line no-undef
      this.stripe = Stripe(this.$store.getters.storeInfo.publishableKey);
    }
  },
  beforeCreate() {
    if (this.$store.getters.storeInfo) {
      this.$store.dispatch("checkout/loadDeliveryServices");
      // eslint-disable-next-line no-undef
      this.stripe = Stripe(this.$store.getters.storeInfo.publishableKey);
    }
  },
  created() {
    const self = this;
    if (this.$store.getters.storeInfo) {
      this.$store.dispatch("checkout/loadDeliveryServices");
      this.handlerLoadTab();
    }
    if (self.$store.getters.checkAuth) {
      self.$store.dispatch("customer/setOption", 1);
      self.$checkoutValidator.customerInfo();
    }
  },
  mounted() {
    const self = this;
    self.posicionarCard();
    $(window).scroll(function () {
      self.posicionarCard();
    });
    self.$appPageTitle.tab(this.$route.name);
    if (!this.$store.getters.storeOnline.status) {
      this.$router.replace({
        name: "CartNotFound",
      });
    }
    if (self.$store.getters.checkAuth) {
      self.$store.dispatch("customer/setOption", 1);
      self.$checkoutValidator.customerInfo();
    }
  },
  methods: {
    handlerLoadTab() {
      if (this.$store.getters.storeInfo) {
        const services = [];
        for (const service of this.$store.getters.deliveryServicesList) {
          if (service.serviceName === "Pickup") {
            services.push("Pickup");
          } else if (service.serviceName === "Delivery") {
            services.push("Delivery");
          }
        }

        if (services.length > 0) {
          const hasPickup = services.includes("Pickup");

          if (hasPickup) {
            this.tab = "pickup";
            this.$store.dispatch(
              "delivery/setDeliveryMethod",
              "pickup-service"
            );
            this.$store.dispatch("delivery/removeDeliveryDetails");
            this.$store.dispatch("delivery/resetAll");
          } else if (services.includes("Delivery")) {
            this.tab = "delivery";
            this.$store.dispatch(
              "delivery/setDeliveryMethod",
              "delivery-service"
            );
          }
          this.$checkoutValidator.deliveryInfo();
          this.$checkoutValidator.minOrderAmount();
          this.$store.dispatch("cart/setLoad");
        }
      }
    },
    handleTabChange(tab) {
      this.tab = tab;
      console.log(`Selected tab: ${tab}`);
      const serviceSlug =
        tab === "pickup" ? "pickup-service" : "delivery-service";
      this.$store.dispatch("delivery/setDeliveryMethod", serviceSlug);
      if (serviceSlug === "pickup-service") {
        this.$store.dispatch("delivery/removeDeliveryDetails");
        this.$store.dispatch("delivery/resetAll");
        // this.$checkoutValidator.deliveryInfo();
        // this.$checkoutValidator.minOrderAmount();
      }
      this.$store.dispatch("cart/setLoad");
    },
    handlerCleanPaymentData: function () {
      this.paymetInfo = [];
    },
    posicionarCard() {
      // Get main left column and checkout card DOM
      const $left = $(".header");
      const $checkout = $(".fixed-card-container");

      if (!$left.length || !$checkout.length) return;

      // How far from top to bottom of left column
      const leftTop = $left.offset().top;
      const leftHeight = $left.outerHeight();
      const leftBottom = leftTop + leftHeight;

      // How far has user scrolled (top of viewport)
      const scrollTop = $(window).scrollTop();
      const checkoutHeight = $checkout.outerHeight();
      const $checkoutCol = $checkout.parent();
      const parentTop = $checkoutCol.offset().top;
      const stopFixed = leftBottom - checkoutHeight - 32;

      if (scrollTop < parentTop - 100) {
        $checkout.css({
          position: "static",
          top: "auto",
          bottom: "auto",
        });
      } else if (scrollTop >= stopFixed) {
        // Below the bottom, so anchor at bottom
        $checkout.css({
          position: "fixed",
          top: "auto",
          bottom: "32px",
        });
      } else {
        // Normal fixed mode
        $checkout.css({
          position: "fixed",
          top: "100px",
          bottom: "auto",
        });
      }
    },
    createPaymentIntent: async function (checkoutData) {
      try {
        checkoutData.redirectUrl = `${window.location.origin}/${this.$route.params.id}/payment`;
        const form = new Form(checkoutData);
        const { data } = await form.post("/app/orders/payment");
        console.log("create intend", data);
        return data;
      } catch (e) {
        if (e.response && e.response.data && e.response.data.message) {
          const msg = e.response.data.message.toUpperCase();
          if (msg === "SESSION_EXIST" || msg === "SHOPPING_NOT_FOUND") {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: this.$t("errors.session_exist"),
              confirmButtonText: "Reset",
              showCloseButton: true,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.cleanShoppingCart();
              }
            });
          } else if (msg === "PAYMENT_TYPE_NOT_ALLOWED") {
            this.$store.dispatch("checkout/setValidationPaymentInfo", {
              status: false,
              message: i18n.t("errors.PAYMENT_TYPE_NOT_ALLOWED"),
            });
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: this.$t("errors.PAYMENT_TYPE_NOT_ALLOWED"),
              confirmButtonText: "Ok",
              showCloseButton: true,
            });
          } else if (msg === "NOT_YOUR_PAYMENT_ACCOUNT") {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: this.$t("errors.NOT_YOUR_PAYMENT_ACCOUNT"),
              confirmButtonText: "Ok",
              showCloseButton: true,
            });
          } else if (msg === "SELECTED_TIME_NOT_ALLOWED") {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: this.$t("errors.SELECTED_TIME_NOT_ALLOWED"),
              confirmButtonText: "Ok",
              showCloseButton: true,
            });
          } else if (msg === "DELIVERY_PARTNER_DECLINED") {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: this.$t("errors.DELIVERY_PARTNER_DECLINED"),
              confirmButtonText: "Ok",
              showCloseButton: true,
            });
          } else if (msg === "MINIMUM_AMOUNT_NOT_REACHED") {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: this.$t("errors.MINIMUM_AMOUNT_NOT_REACHED"),
              confirmButtonText: "Ok",
              showCloseButton: true,
            });
          } else if (msg === "PRODUCT_NOT_AVAILABLE_FOR_ORDER_YET") {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: this.$t("errors.PRODUCT_NOT_AVAILABLE_FOR_ORDER_YET"),
              confirmButtonText: "Ok",
              showCloseButton: true,
            });
          } else if (msg === "PRODUCT_REQUIRES_SPECIFIC_DATE") {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: this.$t("errors.PRODUCT_REQUIRES_SPECIFIC_DATE"),
              confirmButtonText: "Ok",
              showCloseButton: true,
            });
          } else if (msg === "PRODUCTS_REQUIRE_DIFFERENT_DATES") {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: this.$t("errors.PRODUCTS_REQUIRE_DIFFERENT_DATES"),
              confirmButtonText: "Ok",
              showCloseButton: true,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: this.$t("errors.COMMON_ERROR"),
              confirmButtonText: "Ok",
              showCloseButton: true,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: this.$t("errors.error_alert_title"),
            text: this.$t("errors.COMMON_ERROR"),
            confirmButtonText: "Ok",
            showCloseButton: true,
          });
        }
      }
    },
    // handlerCompleteOrder: async function (checkoutData, paymentIntentId) {
    //   const self = this;
    //   let form = new Form({ ...checkoutData, paymentIntentId });
    //   try {
    //     const { data } = await form.post("/app/orders/cart/checkoutV4");
    //
    //     switch (true) {
    //       case data.status === "Success":
    //         if (
    //           self.$store?.getters?.storeInfo.configs.redirectThanksUrl ||
    //           self.$store?.getters?.storeInfo.configs.redirectThanksUrl !== ""
    //         ) {
    //           await self.$router.push({
    //             name: "Redirect",
    //             params: {
    //               url: self.$store.getters.storeInfo.configs.redirectThanksUrl,
    //             },
    //           });
    //         } else {
    //           await self.$router.push({
    //             name: "Thanks",
    //             params: { orderref: data.data.orderRef },
    //           });
    //         }
    //
    //         Toast.fire({
    //           icon: "success",
    //           title: data.message,
    //         });
    //         break;
    //       case data.status === "false":
    //         Swal.fire({
    //           icon: "error",
    //           title: this.$t("errors.error_alert_title"),
    //           text: data.data.message,
    //           reverseButtons: true,
    //           confirmButtonText: "ok",
    //         });
    //         await self.$store.dispatch("loading/done");
    //         break;
    //       default:
    //         Swal.fire({
    //           icon: "error",
    //           title: this.$t("errors.error_alert_title"),
    //           text: data.data.message,
    //           reverseButtons: true,
    //           confirmButtonText: "ok",
    //         });
    //         await self.$store.dispatch("loading/done");
    //         break;
    //     }
    //   } catch (e) {
    //     if (e.response && e.response.data && e.response.data.message) {
    //       const msg = e.response.data.message.toUpperCase();
    //       if (msg === "ALREADY_EXIST") {
    //         Swal.fire({
    //           icon: "error",
    //           title: this.$t("errors.error_alert_title"),
    //           text: this.$t("errors.ALREADY_EXIST"),
    //           confirmButtonText: "Ok",
    //           showCloseButton: true,
    //         });
    //       } else if (
    //         msg === "NOT_VALIDATED_YET" ||
    //         msg === "VALIDATED_TYPE_NOT_SAME" ||
    //         msg === "PAYMENT_FAILED"
    //       ) {
    //         Swal.fire({
    //           icon: "error",
    //           title: this.$t("errors.error_alert_title"),
    //           text: this.$t("errors.NOT_VALIDATED_YET"),
    //           confirmButtonText: "Ok",
    //           showCloseButton: true,
    //         });
    //       } else if (msg === "DELIVERY_PARTNER_DECLINED") {
    //         Swal.fire({
    //           icon: "error",
    //           title: this.$t("errors.error_alert_title"),
    //           text: this.$t("errors.DELIVERY_PARTNER_DECLINED"),
    //           confirmButtonText: "Ok",
    //           showCloseButton: true,
    //         });
    //       } else if (msg === "SAVE_ORDER_FAILED") {
    //         Swal.fire({
    //           icon: "error",
    //           title: this.$t("errors.error_alert_title"),
    //           text: this.$t("errors.SAVE_ORDER_FAILED"),
    //           confirmButtonText: "Ok",
    //           showCloseButton: true,
    //         });
    //       } else {
    //         Swal.fire({
    //           icon: "error",
    //           title: this.$t("errors.error_alert_title"),
    //           text: this.$t("errors.COMMON_ERROR"),
    //           confirmButtonText: "Ok",
    //           showCloseButton: true,
    //         });
    //       }
    //     }
    //   }
    // },
    handlerCompletePayment: async function (
      intentId,
      client_secret,
      payment_method,
      checkoutData
    ) {
      const self = this;
      console.log({ payment_method, client_secret, intentId });
      // const form = new Form({ client_secret, payment_method, customer });
      // const { data } = await form.post("/app/orders/payment");
      self.stripe
        .confirmCardPayment(client_secret, {
          payment_method,
          // customer: "cus_Nq8wJzQQOr8FYe",
          // receipt_email: self.$store.getters.checkAuth
          //   ? self.$store.getters.user.email
          //   : self.$store.getters.guestInfo.email,
        })
        .then((res) => {
          if (res.error) {
            // Handle errors here
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: res.error.message,
              reverseButtons: true,
              confirmButtonText: "ok",
            });
            self.$store.dispatch("loading/done");
            console.log("217", res.error);
          } else if (
            res.paymentIntent &&
            res.paymentIntent.status === "requires_action"
          ) {
            // The payment requires 3D Secure authentication
            self.stripe
              .handleCardAction(res.paymentIntent.client_secret)
              .then((result) => {
                if (result.error) {
                  // Handle authentication error
                  console.log("Authentication error", result.error);
                  self.$store.dispatch("loading/done");
                } else {
                  // Authentication succeeded, reconfirm the payment
                  self.stripe
                    .confirmCardPayment(client_secret, {
                      payment_method: result.paymentMethod.id,
                    })
                    .then((confirmedPayment) => {
                      if (confirmedPayment.error) {
                        // Handle reconfirmation error
                        console.log(
                          "Reconfirmation error",
                          confirmedPayment.error
                        );
                      } else {
                        // Payment succeeded after authentication, handle the result here
                        console.log("Payment succeeded", confirmedPayment);
                        self.handlerCompleteOrder(
                          checkoutData,
                          confirmedPayment.paymentIntent.id
                        );
                      }
                      self.$store.dispatch("loading/done");
                    });
                }
              });
          } else {
            // Payment succeeded, handle the result here
            console.log("Payment succeeded", res);
            self.handlerCompleteOrder(checkoutData, res.paymentIntent.id);
          }
          self.$store.dispatch("loading/done");
        })
        .catch((e) => {
          console.error("error", e);
          self.$store.dispatch("loading/done");
        });
    },
    checkoutX: async function () {
      const self = this;
      let deliveryMethod = _.find(this.$store.getters.deliveryServicesList, {
        serviceSlug: this.$store.getters.deliveryMethod,
      });
      const checkoutData = {
        storeId: self.$store.getters.storeInfo.id,
        serviceId: deliveryMethod.id,
        sessionId: self.$store.getters.guestSessionId,
        userStreetName: self.$store.getters.guestAddress.street,
        userBuildingNo: self.$store.getters.guestAddress.buildingNumber,
        userPostCode: self.$store.getters.guestAddress.postalCode,
        userCity: self.$store.getters.guestAddress.city,
        userFloor: self.$store.getters.guestAddress.floor,
        isAsap: self.$store.getters.deliveryIsAsap,
        dropOffDescription: self.comments,
        contactLessDelivery: self.$store.getters.deliveryOptionDoor ? 1 : 0,
        paymentType: self.$store.getters.paymentType,
        useCredits: self.$store.getters.useCredit ? 1 : 0,
        offerCode: self.$store.getters.offer?.code,
      };
      if (self.$store.getters.checkAuth) {
        checkoutData.isGuest = 0;
      } else {
        checkoutData.isGuest = 1;
        checkoutData.userFirstName = self.$store.getters.guestInfo.firstName;
        checkoutData.userLastName = self.$store.getters.guestInfo.lastName;
        checkoutData.userEmail = self.$store.getters.guestInfo.email;
        checkoutData.userPhone =
          self.$store.getters.guestInfo.phoneNumber.replace(/\s/g, "");
      }

      if (self.offerCode) {
        checkoutData.offerCode = self.offerCode;
        checkoutData.isApp = 0;
      }

      if (!self.$store.getters.deliveryIsAsap) {
        checkoutData.dropOffDateTime =
          self.$store.getters.deliveryDropoffDateTime;
      }
      self.$store.dispatch("loading/start");
      // self.stripe
      if (self.$store.getters.paymentType === "online-payment") {
        let payment_method;
        if (self.$store.getters.checkAuth) {
          const paymentAccountId = self.paymetInfo;
          const { data } = await axios.get("/users/profiles/payment/method");
          const temp = data.data;
          console.log("account -id", self.paymetInfo, temp);
          const index = temp.findIndex((v) => v.id === paymentAccountId);
          if (index !== -1) {
            console.log("cus id ", temp[index].cardId);
            payment_method = temp[index].cardId;
            checkoutData.paymentAccountId = temp[index].id;
          }
        } else {
          if (self.$store.getters.appInfo.paymentProvider === "stripe") {
            payment_method = {
              card: self.$store.getters.cardInputElement.cardNumberElement,
            };
          }
        }
        if (self.$store.getters.isNewFlatPayMethod) {
          delete checkoutData.paymentAccountId;
        }
        self.createPaymentIntent(checkoutData).then((res) => {
          if (res.status === "Success") {
            if (res.data === "CASH_PYAMENT") {
              self.handlerCompleteOrder(
                { ...checkoutData, paymentType: "cash" },
                undefined
              );
            }
            const intent_id = res.data.intent_id;
            const client_secret = res.data.client_secret;
            if (self.$store.getters.appInfo.paymentProvider === "flatpay") {
              const fp_id = res.data.fp_id;
              const url = res.data.url;
              const paymentType = self.$store.getters.checkAuth
                ? "ADD_PAYMENT"
                : "CHECKOUT";
              const flatPayCheckoutData = {
                paymentType,
                fp_id,
                url,
                checkoutData,
              };
              self.$store.dispatch(
                "checkout/setFlatPayCheckoutData",
                flatPayCheckoutData
              );
              localStorage.setItem(
                "flatPayCheckoutData",
                JSON.stringify(flatPayCheckoutData)
              );
              self.$store.dispatch("loading/done");
              this.$router.push({ name: "FlatPayPayment" });
            } else {
              self.handlerCompletePayment(
                intent_id,
                client_secret,
                payment_method,
                checkoutData
              );
            }
          } else {
            // Toast.fire({
            //   icon: "error",
            //   title: res.message,
            // });
          }
        });
      } else {
        self.createPaymentIntent(checkoutData).then((res) => {
          if (res.status === "Success") {
            self.handlerCompleteOrder(checkoutData, undefined);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#custom-button {
  height: 30px;
  outline: 1px solid grey;
  background-color: green;
  padding: 5px;
  color: white;
}
/* Fixed toolbar styling */
.fixed-toolbar {
  z-index: 10;
  width: 100%;
  top: 0;
  position: fixed !important;
}

/* Main content adjustments */
.main-content {
  position: relative;
  /* Padding-top will be set dynamically in mounted() */
}

/* Content that scrolls */
.content-column {
  height: 100%;
  overflow-y: auto;
}

/* Fixed checkout card for desktop */
.checkout-card-column {
  position: relative;
  height: 100%;
}

.fixed-card-container {
  position: fixed;
  top: 100px; /* Toolbar height + small gap */
  width: inherit;
  max-width: inherit;
  z-index: 5;
}

/* Make sure checkout card doesn't go off-screen */
@media (min-width: 960px) {
  .fixed-card-container {
    width: 41.6667%; /* Same as md-5 */
  }
}
@media (min-width: 1904px) {
  .fixed-card-container {
    width: 33.3333%; /* Same as xl-4 */
  }
}
</style>
